type UrlParams = Record<string, string | number | null | undefined>;

const ROOM_ID_PARAM = 'roomId';

const getValidParams = (params: UrlParams) => {
    return Object.keys(params)
        .filter(key => params[key] !== null && params[key] !== undefined && `${params[key]}` !== '')
        .map(key => [key, `${params[key]}`] as [string, string]);
};

const decodeUrlParam = (value: string) => {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};

const appendParamsToUrlPart = (urlPart: string, params: Array<[string, string]>) => {
    const queryIndex = urlPart.indexOf('?');
    const path = queryIndex === -1 ? urlPart : urlPart.slice(0, queryIndex);
    const queryString = queryIndex === -1 ? '' : urlPart.slice(queryIndex + 1);
    const paramKeys = params.map(([key]) => key);
    const existingParams = queryString
        ? queryString.split('&').filter(item => {
              const [key] = item.split('=');
              return paramKeys.indexOf(decodeUrlParam(key)) === -1;
          })
        : [];
    const nextParams = params.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    const nextQueryString = existingParams.concat(nextParams).join('&');

    return nextQueryString ? `${path}?${nextQueryString}` : path;
};

export const appendUrlParams = (url: string, params: UrlParams) => {
    const validParams = getValidParams(params);

    if (!url || !validParams.length) return url;

    const hashIndex = url.indexOf('#');
    if (hashIndex === -1) {
        return appendParamsToUrlPart(url, validParams);
    }

    const urlWithoutHash = url.slice(0, hashIndex);
    const hash = url.slice(hashIndex);
    const shouldAppendToHash = hash.startsWith('#/') || hash.includes('?');

    if (shouldAppendToHash) {
        return `${urlWithoutHash}#${appendParamsToUrlPart(hash.slice(1), validParams)}`;
    }

    return `${appendParamsToUrlPart(urlWithoutHash, validParams)}${hash}`;
};

export const appendRoomIdToUrl = (url: string, roomId?: string | number | null) => {
    return appendUrlParams(url, { [ROOM_ID_PARAM]: roomId });
};

export function openWebExtraUrl(url: string, target = '_blank') {
    const a = document.createElement('a');
    a.target = target;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

// export function openElectronExtraUrl(url: string) {
//     const electron = require('electron');
//     electron?.shell?.openExternal(url);
// }
